module.exports = __webpack_public_path__ + "eed3ad964c418c54f89ea3892295d08c.png";